import {PureComponent} from "react"
import PropTypes from 'prop-types'

import Card from "../Styled/Dasboard/Card.jsx"
import CardCol from "../Styled/Dasboard/CardCol.jsx"
import CardRow from "../Styled/Dasboard/CardRow.jsx"
import Picture from "../../components/Picture/Picture.jsx"

import linkedinLogo from './assets/images/icn-linkedin.svg'
import IconMail from './assets/images/icn-mail.svg'
import IconPhone from './assets/images/icn-phone.svg'

import './FreelanceAgent.scss'

export default class FreelanceAgent extends PureComponent {

  static propTypes = {
    agent: PropTypes.object.isRequired,
    title: PropTypes.string,
    whatsApp: PropTypes.bool,
    appointmentCta: PropTypes.bool,
  }

  static defaultProps = {
    title: 'Mon agent de carrière',
    whatsApp: false,
    appointmentCta: true,
  }

  render() {
    const {agent, title, appointmentCta, whatsApp} = this.props
    const agentImage = agent?.image?.square ?? null
    const tooltipLogo = (agent.linkedin_url) ? linkedinLogo :false
    const calendlyUrl = agent?.calendly_url ?? null

    return (
      <Card  className="dashboard-card-agent" title={title}>
        <CardRow align="center">
          <CardCol basis="150px" flex="unset" style={{maxWidth: '160px'}}>
            {agent.linkedin_url
              ? <a href={agent.linkedin_url} target="_blank" rel="noreferrer noopener">
                <Picture
                  src={agentImage}
                  alt={agent.linkedin_url}
                  className="picture mx-auto"
                  size={'150px'}
                  style={{maxWidth: '150px'}}
                  tooltipLogo={tooltipLogo}
                />
              </a>
              : <Picture
                src={agentImage}
                alt={agent.linkedin_url}
                className="picture mx-auto"
                size={'150px'}
                style={{maxWidth: '150px'}}
                tooltipLogo={tooltipLogo}
              />
            }
          </CardCol>

          <CardCol flex="1">
            <CardRow className="agent-info" direction="column" gap="20px" p="0" >
              <CardCol className="agent-info-fullname">{agent.fullname}</CardCol>
              <CardCol className="agent-info-email">
                <img src={IconMail} height="24px" alt="Email de l'agent"/>
                {(agent.email)? agent.email: null}
              </CardCol>
              <CardCol className="agent-info-phone">
                <img src={IconPhone} height="24px" alt="Email de l'agent"/>
                {agent.tel}
              </CardCol>
            </CardRow>
          </CardCol>
        </CardRow>

        {appointmentCta && calendlyUrl && (
          <CardRow className={"freelance-agent-appointment"} align="center" wrap="wrap">
            <CardCol className={'test'} flex="1">
              Réservez un rendez vous téléphonique de 15 min :
            </CardCol>
            <CardCol flex='unset'>
              <a className="btn btn-primary" href={calendlyUrl} target="_blank" rel="noopener noreferrer">Je réserve</a>
            </CardCol>
          </CardRow>
        )}

        {whatsApp && (
          <CardRow align="center" wrap="wrap" p="0 0 20px 0">
            <CardCol flex="1" align="center">
              Je vous réponds aussi sur Whatsapp !
            </CardCol>
          </CardRow>
        )}
      </Card>
    )
  }
}